// extracted by mini-css-extract-plugin
export default {"wrapper":"product_wrapper__1eZ+w","body":"product_body__YfwUd","main_wrapper":"product_main_wrapper__Zg5Ne","title":"product_title__La0JN","content":"product_content__oHZds"};